export default __webpack_public_path__ + "static/media/NotoSans-Italic.9afb910f.eot";